import React, {useRef} from 'react';
import {Toast} from "primereact/toast";

const WithToastPage = ({card=true,children}:any) => {
    const toast = useRef<Toast | null>(null);
    if(card){
        return (
            <div className="card">
                <Toast ref={toast}/>
                {children}
            </div>
        );
    }
    return (
        <div>
            <Toast ref={toast}/>
            {children}
        </div>
    );
};

export default WithToastPage;